module.exports = {
	"APP": {
		"URL": "http://85.215.150.174:3001",
		"ADMIN": {
			"TITLE": "GuernCMS",
			"TITLE_MINI": "GC"
		},
		"FRONT": {
			"TITLE": "Forgotten Records"
		},
		"LANGUAGES": {
			"SUPPORTED": [
				"fr",
				"en"
			],
			"PREFERRED": "en",
			"SQUASH": false,
			"COOKIE_DAY_AGE": 730
		}
	},
	"STORE": {
		"DB": {
			"HOST": "mongodb://admin:YgXrK5WMB3Bh@85.215.150.174:27028/forgottenrecords_1?authSource=admin"
		},
		"ELASTICSEARCH": {
			"HOST": "http://85.215.150.174:9211/",
			"INDEX": {
				"record": "forgottenrecords_record",
				"writing": "forgottenrecords_writing"
			}
		}
	},
	"DATA": {
		"covers": "data/covers",
		"images": "data/images"
	},
	"CART": {
		"PAYPAL": {
			"ENV": "production"
		},
		"SHIPPING_FIRST": 9.7,
		"SHIPPING_OTHER": 3,
		"COOKIE_DAY_AGE": 30
	},
	"CATALOGUE": {
		"FEATURED": false,
		"SEARCH": {
			"SUGGESTIONS": {
				"ORDER": [
					"composer",
					"soloist",
					"conductor"
				]
			}
		},
		"THUMB": {
			"CACHE": true,
			"RESIZE_ALGO": "RESIZE_BICUBIC",
			"HEIGHT": 350,
			"RECOMPRESS": true,
			"RECOMPRESS_TARGET": 0.85,
			"RECOMPRESS_MIN": 85,
			"RECOMPRESS_TARGET_LAZY": 0.02,
			"RECOMPRESS_MIN_LAZY": 2
		},
		"RECORD_TITLE_TRUNCATE": "75"
	},
	"SPECIAL": {
		"TITLE_TRUNCATE": "70"
	},
	"HOME": {
		"FEATURED": false
	},
	"PAGE_NOT_FOUND": {
		"TIMEOUT": 5000
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/app/app.config.json
// module id = 462
// module chunks = 0